import { render, staticRenderFns } from "./InventoryAdvancePaymentAddAttachmentsFormDialog.vue?vue&type=template&id=1b4035a4&"
import script from "./InventoryAdvancePaymentAddAttachmentsFormDialog.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentAddAttachmentsFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports